import {
  LocalStorage,
  SessionStorage,
  CookieStorage,
} from "@sopheos/orbjs_storage";

/**
 * @type LocalStorage
 */
let _instanceLocal = null;
/**
 * @type SessionStorage
 */
let _instanceSession = null;
/**
 * @type CookieStorage
 */
let _instanceCookie = null;

export function useLocalStorage() {
  if (!_instanceLocal) {
    let prefix = "";
    switch (import.meta.env.VITE_MODE) {
      case "developpement":
        prefix = `LOCAL_AGENDA_ADMIN`;
        break;
      case "testing":
        prefix = `DEV_AGENDA_ADMIN`;
        break;
      default:
        prefix = "AGENDA_ADMIN";
        break;
    }
    _instanceLocal = new LocalStorage(prefix);
  }
  return _instanceLocal;
}

export function useSessionStorage() {
  if (!_instanceSession) {
    let prefix = "";
    switch (import.meta.env.VITE_MODE) {
      case "developpement":
        prefix = `LOCAL_AGENDA_ADMIN`;
        break;
      case "testing":
        prefix = `DEV_AGENDA_ADMIN`;
        break;
      default:
        prefix = "AGENDA_ADMIN";
        break;
    }
    _instanceSession = new SessionStorage(prefix);
  }
  return _instanceSession;
}

export function useCookieStorage() {
  if (!_instanceCookie) {
    _instanceCookie = new CookieStorage();
  }
  return _instanceCookie;
}
